import type { FaireProductEntity } from "../../entity_types/product";

export const p_azjnajjgcg: FaireProductEntity = {
  token: "p_azjnajjgcg",
  type: "product",
  name: "PRETTY BASH Solid Pointelle Knit Open Front Cardigan",
  brandToken: "b_b5qvtl6s4w",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d21851d315ba23abfc9d540c5814bc281066c4ea04ac545c260878aa5a566fab.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d05796d4b963fc069165705c31f2df9afe53183375144d1bba8b6e78be13a36b.jpeg",
    "https://cdn.faire.com/fastly/a819264d02e0752d3a970e0324cf5ff1e267245253a3d60331b3b180f7f0117f.jpeg",
    "https://cdn.faire.com/fastly/bcd4a4661013cfc1b7f52d69a515a2908718951e165bb326dd17b9aa0f5ab596.jpeg",
    "https://cdn.faire.com/fastly/f56220c8696e06d860bd5b2d7d5005bf88f96d0af204c87a8ac31519ece13ff8.jpeg",
    "https://cdn.faire.com/fastly/503a0a9de262f060d9249bdaad5225581e085b13500bd3a9e0d5aeb32d6c5c2a.jpeg",
  ],
  priceDollars: 32,
  description:
    "Elevate your layering game with this delicate open-front cardigan, crafted from a refined pointelle knit that adds subtle texture and understated elegance. The relaxed silhouette drapes beautifully over any top, making it the perfect piece for creating polished, feminine outfits. Whether styled with a vest and skirt or worn solo, this versatile cardigan brings sophistication to your everyday wardrobe. 100% Acrylic\n\nSize info:\nSee size chart for approximate measurements\n\n",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:11.738Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
